<script setup>
import ConfigurationProvider from '@/provider/configuration.js'
</script>

<template>

  <footer class="app-footer main-footer">
    <div class=" footer-text d-flex justify-content-center align-content-center">
      <span>{{ ConfigurationProvider.getConfig().app.appName }}</span>
      <span class="px-1">|</span>
      <span>Versione {{ ConfigurationProvider.getConfig().app.appVersion }}</span>
      <span class="square ms-3"></span>
      <strong class="footer-powered-by">
        <span>Powered by: </span>
        <a :href="ConfigurationProvider.getConfig().app['dpaFooterLink']">{{ ConfigurationProvider.getConfig().app['dpaFooterName'] }}</a>
      </strong>
    </div>
  </footer>

</template>

<style scoped>

</style>
